import { useCallback, useEffect, useState } from "react";
import {
  findGalleryIndex,
  reconcileGalleryIndex,
  stepGalleryIndex,
} from "../utils/allTimeGreats";

export const useGreatsGallery = (items = []) => {
  const [playerId, setPlayerId] = useState(null);
  const index = findGalleryIndex(items, playerId);
  const open = index >= 0;

  useEffect(() => {
    if (playerId && reconcileGalleryIndex(items, playerId) == null) {
      setPlayerId(null);
    }
  }, [items, playerId]);

  const openAt = useCallback((id) => {
    if (id) setPlayerId(id);
  }, []);

  const close = useCallback(() => setPlayerId(null), []);

  const step = useCallback(
    (delta) => {
      if (!open) return;
      const nextIndex = stepGalleryIndex(index, delta, items.length);
      const nextId = items[nextIndex]?.playerId;
      if (nextId) setPlayerId(nextId);
    },
    [index, items, open]
  );

  return {
    open,
    index: open ? index : 0,
    item: open ? items[index] : null,
    count: items.length,
    openAt,
    close,
    step,
  };
};
